let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("299Ti")).then(() => parcelRequire('kpNZg'));